module.exports = __webpack_public_path__ + "6de364d12957e1a7966441e7dc30d8fc.png";